import React, { useEffect, useState } from 'react';

const Pictures = (props) => {

  const [transform, setTransform] = useState(`rotate(5deg)`)
  const [picNumber, setPicNumber] = useState(11)
  const [url, setUrl] = useState(`pics/pics/${11}.jpg`)
  const maxPicNumber = 102;

  function randomIntFromInterval(min, max) { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min)
  }
  
  useEffect(()=>{
    const timeout = setTimeout(() => {
      // var newPicNumber = picNumber+1;
      // if (newPicNumber > maxPicNumber) {
      //     newPicNumber = 1;
      // }
      
      var newPicNumber = randomIntFromInterval(1, maxPicNumber);

      setTimeout(() => {
        if(transform === "rotate(5deg)")setTransform("rotate(3deg)")
        if(transform === "rotate(3deg)")setTransform("rotate(-5deg)")
        if(transform === "rotate(-5deg)")setTransform("rotate(-2deg)")
        if(transform === "rotate(-2deg)")setTransform("rotate(-3deg)")
        if(transform === "rotate(-3deg)")setTransform("rotate(2deg)")
        if(transform === "rotate(2deg)")setTransform("rotate(1deg)")
        if(transform === "rotate(1deg)")setTransform("rotate(0deg)")
        if(transform === "rotate(0deg)")setTransform("rotate(-4deg)")
        if(transform === "rotate(-4deg)")setTransform("rotate(4deg)")
        if(transform === "rotate(4deg)")setTransform("rotate(-1deg)")
        if(transform === "rotate(-1deg)")setTransform("rotate(-5deg)")
      },2000)

      setPicNumber(newPicNumber)
      setUrl(`pics/pics/${newPicNumber}.jpg`)
        
    }, 5000);

    return () => clearTimeout(timeout);
  }, [picNumber, transform])


  return (    <>
    {
      props.display && <div style={{backgroundColor:"black", width: "99vw", height: "99vh", border: "0px solid black", display: 'flex', flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <div style={{ width: "80vw", height: "80vh", display: 'flex', flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <div style={{ height: "80vh", transform: transform, transition: "0.5s", boxShadow: "8px 8px 8px 8px rgba(0,0,0,0.5)", backgroundColor: "white", padding: 10, borderRadius: 10 }}>
            <img alt='' src={url} style={{ height: "80vh", borderRadius: 10 }}></img>
          </div>

        </div>
      </div>}
  </>
  
);
};

export default Pictures;
